"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Practice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmartActionEventTriggerToJSON = exports.SmartActionEventTriggerFromJSONTyped = exports.SmartActionEventTriggerFromJSON = exports.SmartActionEventTrigger = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var SmartActionEventTrigger;
(function (SmartActionEventTrigger) {
    SmartActionEventTrigger["AppointmentIsBooked"] = "appointment-is-booked";
    SmartActionEventTrigger["AppointmentStarts"] = "appointment-starts";
    SmartActionEventTrigger["AppointmentEnds"] = "appointment-ends";
    SmartActionEventTrigger["AppointmentOutcomeUpdated"] = "appointment-outcome-updated";
    SmartActionEventTrigger["FormIsSubmitted"] = "form-is-submitted";
    SmartActionEventTrigger["SendFormReminder"] = "send-form-reminder";
    SmartActionEventTrigger["PaymentIsCompleted"] = "payment-is-completed";
    SmartActionEventTrigger["PackageIsBooked"] = "package-is-booked";
    SmartActionEventTrigger["PackageIsAssigned"] = "package-is-assigned";
    SmartActionEventTrigger["PackageSessionsCompleted"] = "package-sessions-completed";
    SmartActionEventTrigger["ProductIsPurchased"] = "product-is-purchased";
    SmartActionEventTrigger["InvoiceSendDate"] = "invoice-send-date";
    SmartActionEventTrigger["PackageInstanceIsCreated"] = "package-instance-is-created";
    SmartActionEventTrigger["PackageInstanceRecurringDue"] = "package-instance-recurring-due";
    SmartActionEventTrigger["PackageInstanceEnded"] = "package-instance-ended";
    SmartActionEventTrigger["EventIsBooked"] = "event-is-booked";
    SmartActionEventTrigger["EventStarts"] = "event-starts";
    SmartActionEventTrigger["EventEnds"] = "event-ends";
    SmartActionEventTrigger["InvoiceIsDue"] = "invoice-is-due";
    SmartActionEventTrigger["SubscriptionTrialWillEnd"] = "subscription-trial-will-end";
    SmartActionEventTrigger["TodoAssignment"] = "todo-assignment";
    SmartActionEventTrigger["TodoDueDate"] = "todo-due-date";
    SmartActionEventTrigger["BillingTransactionComputed"] = "billing-transaction-computed";
    SmartActionEventTrigger["PackageTrackingStatusChanged"] = "package-tracking-status-changed";
    SmartActionEventTrigger["PackageIsAtRisk"] = "package-is-at-risk";
    SmartActionEventTrigger["PackageIsOffTrack"] = "package-is-off-track";
    SmartActionEventTrigger["InvoiceUpdatedOnStripe"] = "invoice-updated-on-stripe";
    SmartActionEventTrigger["SubscriptionUpdatedOnStripe"] = "subscription-updated-on-stripe";
    SmartActionEventTrigger["ProductUpdatedOnStripe"] = "product-updated-on-stripe";
    SmartActionEventTrigger["PriceUpdatedOnStripe"] = "price-updated-on-stripe";
    SmartActionEventTrigger["PackageTemplateCreated"] = "package-template-created";
    SmartActionEventTrigger["PackageTemplateUpdated"] = "package-template-updated";
    SmartActionEventTrigger["PackageInstancePaymentCollected"] = "package-instance-payment-collected";
    SmartActionEventTrigger["None"] = "none";
    SmartActionEventTrigger["InvoicePaid"] = "invoice-paid";
    SmartActionEventTrigger["SetupIntentRequiresAction"] = "setup-intent-requires-action";
    SmartActionEventTrigger["PaymentIntentProcessing"] = "payment-intent-processing";
    SmartActionEventTrigger["PackageInstanceUpdated"] = "package-instance-updated";
})(SmartActionEventTrigger || (exports.SmartActionEventTrigger = SmartActionEventTrigger = {}));
function SmartActionEventTriggerFromJSON(json) {
    return SmartActionEventTriggerFromJSONTyped(json, false);
}
exports.SmartActionEventTriggerFromJSON = SmartActionEventTriggerFromJSON;
function SmartActionEventTriggerFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.SmartActionEventTriggerFromJSONTyped = SmartActionEventTriggerFromJSONTyped;
function SmartActionEventTriggerToJSON(value) {
    return value;
}
exports.SmartActionEventTriggerToJSON = SmartActionEventTriggerToJSON;
//# sourceMappingURL=SmartActionEventTrigger.js.map